module.exports = __webpack_public_path__ + "img/infusion.b567a063.svg";